import Header from '@/components/Header';
import HeroSection from '@/components/HeroSection';
import CompanyMotto from '@/components/CompanyMotto';
import GallerySection from '@/components/GallerySection';
import ProductsSection from '@/components/ProductsSection';
import AboutSection from '@/components/AboutSection';
import CertificatesSection from '@/components/CertificatesSection';
import DepartmentsSection from '@/components/DepartmentsSection';
import CustomersSection from '@/components/CustomersSection';
import BlogSection from '@/components/BlogSection';
import Footer from '@/components/Footer';
import SeoHead, { companySchema, SITE_URL } from '@/components/SeoHead';

const Index = () => {
  return (
    <div className="min-h-screen" dir="rtl">
      <SeoHead
        title="کیا الکتروموتور پارت | تولیدکننده الکتروموتور صنعتی"
        description="شرکت کیا الکتروموتور پارت؛ طراح و تولیدکننده الکتروموتورهای صنعتی، هودی، کولری، آکسیال، تانژانت، پرتابل و براشلس در ایران."
        canonicalPath="/"
        keywords={['کیا الکتروموتور', 'تولیدکننده الکتروموتور', 'الکتروموتور صنعتی', 'فن صنعتی', 'الکتروموتور هود', 'الکتروموتور کولری', 'BLDC']}
        structuredData={[
          { '@context': 'https://schema.org', ...companySchema },
          { '@context': 'https://schema.org', '@type': 'WebSite', '@id': `${SITE_URL}/#website`, name: 'کیا الکتروموتور پارت', url: SITE_URL, publisher: { '@id': `${SITE_URL}/#organization` }, inLanguage: 'fa-IR' },
        ]}
      />
      <Header />
      <main className="pt-14 sm:pt-16 md:pt-20">
        <HeroSection />
        <CompanyMotto />
        <GallerySection />
        <ProductsSection />
        <AboutSection />
        <CertificatesSection />
        <DepartmentsSection />
        <CustomersSection />
        <BlogSection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
